// extracted by mini-css-extract-plugin
export var dividerContainer = "_9f-0";
export var line = "_9f-1";